export const curatedCollectionKey = 'GIVZ_MONTHLY';
